import api from "../api";
import { DEFAULT_LANGUAGE, LANGUAGE_KEY } from "../constants/languages";

export const getLanguage = () => (window.localStorage.getItem(LANGUAGE_KEY) as api.LanguageEnum) ?? DEFAULT_LANGUAGE;
